module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section03_01_american-village-e5e35533e858c7036dc61c5b400df4b8.jpg";